import React from 'react';

import { ConfigContextValue } from './config-context.types';

export const ConfigContext = React.createContext<ConfigContextValue>({
  error: null,
  loaded: false,
  config: null,
});

export const useConfigContext = (): ConfigContextValue => React.useContext(ConfigContext);
